import { createSelector } from '@reduxjs/toolkit';
const statsReducer = (state) => state.statsStatus;
export const statsStatusSelector = createSelector(statsReducer, (reducer) => reducer.statsIsOpen);
